export default __webpack_public_path__ + "static/media/icon-error-triangle-small.cf75a99e.svg";